/** Display labels for `application_settings.category` values. */
export const APPLICATION_SETTING_CATEGORY_LABELS = {
  general: 'General',
  company: 'Company & branding',
  reports: 'Reports & PDF',
  menu: 'Navigation & menu',
  feature: 'Features & flags',
  email: 'Email',
  smtp: 'SMTP',
  qms: 'QMS',
  tkt: 'Ticketing',
  ticketing: 'Ticketing',
  integration: 'Integrations',
  security: 'Security',
  ui: 'UI & appearance',
};

export function formatApplicationSettingCategory(key) {
  const normalized = (key ?? '').toString().trim().toLowerCase() || 'general';
  if (APPLICATION_SETTING_CATEGORY_LABELS[normalized]) {
    return APPLICATION_SETTING_CATEGORY_LABELS[normalized];
  }
  return normalized
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
